$('[data-address-reload]').each(function () {
    $(this).on('change', '#' + $(this).data('reloadInput'), () => {
        $(this).load(
            $(this).data('reloadRoute'),
            $(this).find('select, input, textarea').serialize()
                + '&_type=' + $(this).data('reloadType')
                + '&_location=' + $(this).data('reloadLocation')
                + '&_payload=' + JSON.stringify($(this).data('payload'))
        )
    })
});
